import {REG} from "lib/commons/registry";

REG.reg.registerSkin('webzone:page', 1, /* language=CSS */ `
	:host {
		--bgcolor: var(--page-bgcolor);
		--color: var(--page-color);
		--border-color: var(--page-border-color);
		--icon-color: var(--page-icon-color);
		--selection-bgcolor: var(--page-selection-bgcolor);
		--selection-color: var(--page-selection-color);
		--form-bgcolor: var(--page-form-bgcolor);
		--form-color: var(--page-form-color);
		--edit-bgcolor: var(--page-edit-bgcolor);
		--edit-color: var(--page-edit-color);
		--row-bgcolor: var(--page-row-bgcolor);
		--row-inSel-bgcolor: var(--page-row-inSel-bgcolor);
		--row-inSel-unfocus-bgcolor: var(--page-row-inSel-unfocus-bgcolor);
		--tabf-off-bgcolor: var(--page-tabf-off-bgcolor);
		--tabf-bgcolor: var(--page-tabf-bgcolor);
		--tabf-color: var(--page-tabf-color);
		--tabl-select-color: var(--page-tabl-select-color);
		--filter: var(--page-img-filter);
		--hover-filter: var(--page-img-hover-filter);
		--active-filter: var(--page-img-active-filter);
		background-color: var(--bgcolor);
		color: var(--color);
	}
`);

REG.reg.registerSkin('webzone:panel', 1, /* language=CSS */ `
	:host {
		--bgcolor: var(--panel-bgcolor);
		--color: var(--panel-color);
		--border-color: var(--panel-border-color);
		--icon-color: var(--panel-icon-color);
		--selection-bgcolor: var(--panel-selection-bgcolor);
		--selection-color: var(--panel-selection-color);
		--form-bgcolor: var(--panel-form-bgcolor);
		--form-color: var(--panel-form-color);
		--edit-bgcolor: var(--panel-edit-bgcolor);
		--edit-color: var(--panel-edit-color);
		--row-bgcolor: var(--panel-row-bgcolor);
		--row-inSel-bgcolor: var(--panel-row-inSel-bgcolor);
		--row-inSel-unfocus-bgcolor: var(--panel-row-inSel-unfocus-bgcolor);
		--tabf-off-bgcolor: var(--panel-tabf-off-bgcolor);
		--tabf-bgcolor: var(--panel-tabf-bgcolor);
		--tabf-color: var(--panel-tabf-color);
		--tabl-select-color: var(--panel-tabl-select-color);
		--filter: var(--panel-img-filter);
		--hover-filter: var(--panel-img-hover-filter);
		--active-filter: var(--panel-img-active-filter);

		--row-current-bgcolor: var(--page-bgcolor);
		/*--row-current-img-end: none;*/

		background-color: var(--bgcolor);
		color: var(--color);
	}
`);

REG.reg.registerSkin('webzone:item', 1, /* language=CSS */ `
	:host {
		--bgcolor: var(--item-bgcolor);
		--color: var(--item-color);
		--border-color: var(--item-border-color);
		--icon-color: var(--item-icon-color);
		--selection-bgcolor: var(--item-selection-bgcolor);
		--selection-color: var(--item-selection-color);
		--form-bgcolor: var(--item-form-bgcolor);
		--form-color: var(--item-form-color);
		--edit-bgcolor: var(--item-edit-bgcolor);
		--edit-color: var(--item-edit-color);
		--row-bgcolor: var(--item-row-bgcolor);
		--row-inSel-bgcolor: var(--item-row-inSel-bgcolor);
		--row-inSel-unfocus-bgcolor: var(--item-row-inSel-unfocus-bgcolor);
		--tabf-off-bgcolor: var(--item-tabf-off-bgcolor);
	  --tabf-bgcolor: var(--item-tabf-bgcolor);
	  --tabf-color: var(--item-tabf-color);
	  --tabl-select-color: var(--item-tabl-select-color);
	  --filter: var(--item-img-filter);
	  --hover-filter: var(--item-img-hover-filter);
	  --active-filter: var(--item-img-active-filter);
	  background-color: var(--bgcolor);
	  color: var(--color);
  }
`);

REG.reg.registerSkin('webzone:invert', 1, /* language=CSS */ `
	:host {
		--bgcolor: var(--inv-bgcolor);
		--color: var(--inv-color);
		--border-color: var(--inv-border-color);
		--filter: var(--inv-img-filter);
		--hover-filter: var(--inv-img-hover-filter);
		--active-filter: var(--inv-img-active-filter);
		--pressed-bgcolor: var(--inv-pressed-bgcolor);
		--dropdown-url: url(/@skin@/commons/widgets/dropdown-inv.svg);
		background-color: var(--bgcolor);
		color: var(--color);
	}
`);